module.exports = __webpack_public_path__ + "img/1f590c63ad85427d3c709cd8dabfdfc2.ttf";